__turbopack_context__.v({
  "info": "TaxInfoText-module-scss-module__H0RaXa__info",
});
